import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTop } from "../lib/PageUtils";

export default function ScrollToTop() {
    const location = useLocation();

    useEffect(() => {
        scrollToTop();
    }, [location.pathname]);

    return null;
}